<template>
  <div class="row no-gutters">
    <div class="col pr-2" id="application-submitted-date">
      <div class="small text-muted-more">{{$t('LoanApplicationTimeline.submitted')}}</div>
      <div class="text-muted small">{{$d(application.submittedDate)}}</div>
    </div>
    <div class="col pr-2" id="application-submitted-amount">
      <div class="small text-muted-more">{{$t('LoanApplicationTimeline.amount')}}</div>
      <div class="text-amount text-muted small">{{ $n(application.loanAmount, 'currencyNoDecimals') }}</div>
    </div>
    <div class="col" id="application-submitted-period">
      <div class="small text-muted-more">{{$t('LoanApplicationTimeline.period')}}</div>
      <div class="text-amount text-muted small">{{$tc('LoanApplicationTimeline.month', application.loanPeriodInMonths)}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'SubmitApplicationStageComponent',
    props: ['application']
  }
</script>
